/* eslint-disable no-undef */
import axios from 'axios';
import * as types from '../constantes/email';

export const SendEmailAction = (html, title) => async (dispatch, getState) => {
  dispatch({
    type: types.SEND_EMAIL_REQUEST,
    payload: { html, title },
  });
  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/email`,
      { html, title },
      { headers: { Authorization: `bearer ${userInfo.token}` } },
    );
    dispatch({
      type: types.SEND_EMAIL_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.SEND_EMAIL_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};
